import React from 'react';
import { Renderer, RendererProps } from '../factory';
import { ServiceStore, IServiceStore } from '../store/service';
import { Api, SchemaNode, Action } from '../types';
import { filter } from '../utils/tpl';
import cx from 'classnames';
import moment from 'moment';
import { BaseSchema } from '../Schema';
import { ActionSchema } from './Action';
import Popover from 'antd/lib/popover';
import { WrapperBtnPopover } from './Lion/Table/LionTable/style';
// Jay
import { isMobile } from '../utils/helper';
import './Lion/Table/LionTable/style/baseCss/index.css';
import ActionSheet from '../components/Lion/ActionSheet';
import { render as renderAmis } from '../index'
import { Icon } from '../components/icons';
import { Button } from 'antd';
/**
 * 操作栏渲染器。
 * 文档：https://baidu.gitee.io/amis/docs/components/operation
 */
export interface OperationSchema extends BaseSchema {
  /**
   * 指定为操作栏
   */
  type: 'operation';

  /**
   * 占位符
   */
  placeholder?: string;

  buttons: Array<ActionSchema>;
  // Jay
  // 超过num个就折叠
  num?: number;
}


// 不做处理的按钮类型
const specialButtonType = ['rfid-action']
export interface OperationProps
  extends RendererProps,
  Omit<OperationSchema, 'type' | 'className'> {
  // Jay
  useMobileUI?: boolean;
  fold: boolean;
  isFieldTable?: boolean;//是否来自字段表格
  tableRotate?: boolean;//表格横屏模式开启
}
// Jay
interface OperationState {
  isOpened: boolean;
  popUp: boolean;
}
export class OperationField extends React.Component<OperationProps, OperationState> {
  static propsList: Array<string> = ['buttons', 'label'];

  static defaultProps: Partial<OperationProps> = {};
  // Jay
  constructor(props: OperationProps) {
    super(props)
    this.state = {
      isOpened: false,
      popUp: false,
    }
  }
  private moreHandleTouch(e: React.TouchEvent<HTMLDivElement>) {
    e.stopPropagation()
    this.setState({ isOpened: true })
  }
  private renderOperation() {
    // 表格列operation按钮超过num个折叠
    // num这个字段要跟后端约定好

    const { buttons, num, render, env: { getModalContainer }, classnames: cx, tableRotate, useMobileUI, fold, tableLayout, isFieldTable } = this.props;
    const mobileUI = useMobileUI && isMobile();
    const Layout = tableLayout == 'vertical'
    let number = num;
    if (mobileUI) number = num || (isFieldTable ? 2 : 0)
    let count = Number(number)
    let oprations = null;
    let Arraybut = Array.isArray(buttons)
    if (Arraybut && buttons.length) {
      const otherArr = mobileUI ?
        <ActionSheet
          closeOnOutside={false}
          key={'actionSheet'}
          isOpened={this.state.isOpened}
          container={getModalContainer}
          round
          tableRotate={tableRotate}
          onHide={(e: any) => {
            e.stopPropagation()
            this.setState({ isOpened: false })
          }}
          popupContent={<div style={{ width: '100%' }}>
            {
              // buttons.slice(count).map
              buttons.map((button: any, idx: number) => {
                // console.log(button)
                return (
                  <div key={idx} data-index={idx}
                    id="amis-action-sheet-btn-wrapper"
                    className='action-sheet-btn-wrapper'
                    onClick={() => {
                      this.setState({ isOpened: !this.state.isOpened })
                    }}>
                    {
                      button?.type === 'lion-cell-import' ?
                        renderAmis(button, {
                          size: button.size || 'md',
                          level: button.level || (mobileUI ? 'link' : (button.icon && !button.label ? 'link' : '')),
                          key: idx
                        }) :
                        render(
                          `${idx}`,
                          {
                            ...(button as any),
                            type: specialButtonType.includes(button.type) ? button.type : 'button',
                            size: button.size || 'md',
                            level: button.level || (button.icon && !button.label ? 'link' : ''),
                          },
                          {
                            key: idx
                          }
                        )
                    }
                  </div>
                )
              })
            }
          </div>}>
          <span className={cx('Button--link', 'extendBtn', 'rotate', Layout && "btnreset")}
            onClick={this.moreHandleTouch.bind(this)}>
            {
              // count === 0 ? '操作' :
              '···'
            }
          </span>
        </ActionSheet > :
        <WrapperBtnPopover className="lion-export-popover">
          <div className="lion-export-popover-container">
            <div className="lion-export-popover-hide">
              <ul style={{ [buttons.slice(count)?.length <= 1 ? 'padding' : '']: 0 }}>
                {
                  (fold ? buttons : buttons.slice(count)).map((button: any, idx: number) => {
                    if (button?.type === 'lion-cell-import' as any) return renderAmis(button, {
                      size: button.size || 'md',
                      level: button.level || mobileUI ? 'link' : (button.icon && !button.label ? 'link' : ''),
                      key: idx
                    })
                    return <div key={idx} data-index={idx} className="flex justify-center items-center" style={{ height: 'auto' }}>{render(
                      `${idx}`,
                      {
                        ...(button as any),
                        type: specialButtonType.includes(button.type) ? button.type : 'button',
                        size: button.size || 'sm',
                        level:
                          button.level ||
                          (button.icon && !button.label ? 'link' : ''),
                        className: "lion-td-btn"
                      },
                      {
                        key: idx
                      }
                    )}</div>
                  })
                }
              </ul>
            </div>
          </div>
        </WrapperBtnPopover>
      const popover = <Popover key={'btnPopover'} overlayClassName='lion-popover-operation lion-table-cell-btn'
        placement='bottomRight'
        arrowPointAtCenter
        content={otherArr}
        overlayInnerStyle={{ borderRadius: 5 }}
        getPopupContainer={getModalContainer}
        trigger={["hover"]}
        onVisibleChange={(bol) => { fold && this.setState({ popUp: bol }) }}
      >
        {fold ?
          <Button className={cx("Button-arrow")}>
            操作
            <span className={cx('Select-arrow', { "is-opened": this.state.popUp })}>
              <Icon symbol icon="#icon-tooltool_down" className="icon" />
            </span>
          </Button>
          :
          <span className={cx('Button--link', 'extendBtn', count !== 0 && 'rotate')}>···</span>
        }
      </Popover >
      const fixedArr = (!fold && buttons.length > count ?
        (buttons.length - 1 === count) ?
          buttons
          :
          buttons.slice(0, count)
        :
        buttons).map((button, index) => {
          if (button?.type === 'lion-cell-import' as any) {
            return renderAmis(button, {
              size: button.size || 'md',
              level: button.level || mobileUI ? 'link' : (button.icon && !button.label ? 'link' : ''),
              key: index,
              // 在CRUD表格中的 操作按钮的loading始终为false
            }, {loading: false})
          }
          return render(
            `${index}`,
            {
              ...(button as any),
              type: specialButtonType.includes(button.type) ? button.type : 'button',
              size: button.size || 'md',
              level:
                button.level || (mobileUI ? 'link' :
                  (button.icon && !button.label ? 'link' : '')),
              fold
            },
            {
              key: index,
              // 在CRUD表格中的 操作按钮的loading始终为false
              loading: false
            }
          )
        })

      if (fold) {
        oprations = mobileUI ? [otherArr] : [popover]
      } else {
        if (buttons.length > count) {
          if (buttons.length - 1 == count) {
            oprations = mobileUI ? [otherArr] : [...fixedArr]
          } else {
            oprations = mobileUI ? [otherArr] : [...fixedArr, popover]
          }

        } else {
          oprations = fixedArr
        }
      }
    }
    return oprations;
    // return (oprations || [])?.map((item) => ({...item, props: {...item.props, loading: false}}))

  }


  render() {
    const { className, classnames: cx, fold } = this.props;
    return (
      <div className={cx('OperationField', className)} style={{ width: fold ? 56 : 'unset' }}>
        {/* Jay */}
        {this.renderOperation()}
      </div>
    );
  }
}

@Renderer({
  type: 'operation'
})
export class OperationFieldRenderer extends OperationField { }
